import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import { Control } from './add-dns-record-dialog.models';
import { DNSRecordType } from '../../../../shared/models/dns.models';

export const TYPES: { label: string; value: string }[] = [
  { label: 'A (IPV4 Address)', value: DNSRecordType.A },
  { label: 'AAAA (IPV6 Address)', value: DNSRecordType.AAAA },
  { label: 'CNAME (Name Alias)', value: DNSRecordType.CNAME },
  { label: 'NS (Name Server) ', value: DNSRecordType.NS },
  { label: 'MX Record (Mail Exchanger)', value: DNSRecordType.MX },
  { label: 'TXT (Text)', value: DNSRecordType.TXT },
  { label: 'PTR (Pointer Record)', value: DNSRecordType.PTR },
  { label: 'SRV (Service Record)', value: DNSRecordType.SRV },
  { label: 'SPF (Sender Permitted Form)', value: DNSRecordType.SPF },
  { label: 'DKIM (DomainKeys Identified Mail)', value: DNSRecordType.DKIM },
];

export const BASE_CONTROLS: Control[] = [
  { controlName: 'type', label: 'Type', type: 'select', options: TYPES },
  {
    controlName: 'host',
    label: 'Host',
    type: 'text',
    placeholder: 'Enter a hostname',
    hint: 'Leave blank as a default value (@)',
    suffixText: 'hostSuffix',
  },
  {
    controlName: 'target',
    label: 'Value/Target',
    type: 'text',
    placeholder: 'Enter target name',
  },
  { controlName: 'ttl', label: 'TTL', type: 'number', hint: 'Leave it blank as a default value' },
];

export const MX_CONTROLS: Control[] = [
  BASE_CONTROLS[0],
  {
    controlName: 'host',
    label: 'Record Name / Host',
    type: 'text',
    placeholder: 'Enter a hostname',
    hint: 'Leave blank as a default value (@)',
    suffixText: 'hostSuffix',
  },
  BASE_CONTROLS[2],
  {
    controlName: 'priority',
    label: 'Priority',
    type: 'number',
    placeholder: 'Enter number',
    hint: 'Lower numbers are tried first',
  },
  BASE_CONTROLS[3],
];

export const SRV_CONTROLS: Control[] = [
  BASE_CONTROLS[0],
  {
    controlName: 'host',
    label: 'Record Name / Host',
    type: 'text',
    placeholder: 'Enter a hostname',
    hint: 'Leave blank as a default value (@)',
    suffixText: 'hostSuffix',
  },
  BASE_CONTROLS[2],
  {
    controlName: 'service',
    label: 'Service',
    type: 'text',
    placeholder: 'Enter Service Name',
  },
  {
    controlName: 'weight',
    label: 'Weight',
    type: 'number',
  },
  {
    controlName: 'priority',
    label: 'Priority',
    type: 'number',
  },
  BASE_CONTROLS[3],
  {
    controlName: 'protocol',
    label: 'Protocol',
    type: 'radio',
    options: ['TCP', 'UDP', 'TLS'].map((o) => ({ label: o, value: o })),
  },
  {
    controlName: 'port',
    label: 'Port',
    type: 'number',
  },
];

export const CAA_CONTROLS: Control[] = [
  ...BASE_CONTROLS,
  {
    controlName: 'flag',
    label: 'Flag',
    type: 'number',
  },
  {
    controlName: 'tag',
    label: 'Tag',
    type: 'select',
    options: ['issue', 'issuewild', 'iodef'].map((o) => ({ label: o, value: o })),
  },
];

export const TYPE_CONFIGS: Partial<
  Record<
    DNSRecordType,
    Record<
      string,
      [number | string | null, [(control: AbstractControl) => ValidationErrors | null]]
    >
  >
> = {
  [DNSRecordType.CAA]: {
    flag: [0, [Validators.required]],
    tag: ['', [Validators.required]],
  },
  // [DNSRecordType.SOA]: {
  //   responsible_domain: ['', [Validators.required]],
  //   serial_number: [0, [Validators.required]],
  //   refresh_interval: [0, [Validators.required]],
  //   retry_interval: [0, [Validators.required]],
  //   expire_interval: [0, [Validators.required]],
  //   neg_cache_ttl: [0, [Validators.required]],
  // },
  [DNSRecordType.SRV]: {
    service: ['', [Validators.required]],
    protocol: ['TCP', [Validators.required]],
    priority: [null, [Validators.required]],
    weight: [null, [Validators.required]],
    port: [null, [Validators.required]],
  },
  [DNSRecordType.MX]: {
    priority: [null, [Validators.required]],
  },
};
